import { ToastProviderContextProps } from "./ToastProvider";

/**
 * Adds or updates the height of a toast in the height tracking system
 * @param toastId - The unique identifier of the toast
 * @param toastHeight - The height of the toast in pixels
 * @param setToastHeights - Function to update toast heights
 */
export const addOrUpdateToastHeight = (
  toastId: string,
  toastHeight: number,
  setToastHeights: ToastProviderContextProps["setToastHeights"],
) => {
  setToastHeights((prev) => {
    // update height if toast height is defined
    if (prev.find((t) => t.id === toastId)) {
      return prev.map((t) => {
        if (t.id === toastId) {
          return { ...t, height: toastHeight };
        }
        return t;
      });
    }
    // otherwise set height for the first time
    return [
      ...prev,
      {
        id: toastId,
        height: toastHeight,
      },
    ];
  });
};
